import {add_value_to_context} from "./utils";

add_value_to_context('append_to_welcome_text', () => {
  let element = $('.welcome-text');

  element.html(`${new Date().greeting()}, ${element.html()}`);
  element.removeClass('hidden');
});
